import { render, staticRenderFns } from "./HouseholdIncome.vue?vue&type=template&id=ea951d4e"
import script from "./HouseholdIncome.vue?vue&type=script&lang=js"
export * from "./HouseholdIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports